<template>
    <div
        :class="[
      'flex overflow-hidden rounded-lg border border-gray-300',
      sizeClass,
      widthClass,
      wrapperClass,
      disabled && 'opacity-60 pointer-events-none'
    ]"
    >
        <button
            type="button"
            class="flex items-center justify-center bg-gray-100 text-lg min-w-[32px]"
            :disabled="disabled"
            aria-label="Уменьшить количество"
            @click="$emit('dec')"
        >−</button>

        <input
            class="w-full text-center text-sm outline-none"
            :value="modelValue"
            :step="step"
            :min="min"
            :disabled="disabled"
            :inputmode="allowDecimal ? 'decimal' : 'numeric'"
            :aria-label="ariaLabel"
            @input="onInput"
            @keydown.up.prevent="$emit('inc')"
            @keydown.down.prevent="$emit('dec')"
        />

        <button
            type="button"
            class="flex items-center justify-center bg-gray-100 text-lg min-w-[32px]"
            :disabled="disabled"
            aria-label="Увеличить количество"
            @click="$emit('inc')"
        >+</button>
    </div>
</template>

<script>
export default {
    name: "CartQuantityStepper",
    props: {
        modelValue: { type: [Number, String], required: true },
        min: { type: Number, default: 1 },
        step: { type: Number, default: 1 },
        disabled: { type: Boolean, default: false },
        allowDecimal: { type: Boolean, default: true },
        ariaLabel: { type: String, default: "Количество" },

        // стили
        size: { type: String, default: "md" },                 // sm | md | lg
        widthClass: { type: String, default: "w-32" },
        wrapperClass: { type: String, default: "" },
    },
    emits: ["update:modelValue", "inc", "dec"],
    computed: {
        sizeClass() {
            if (this.size === "xs") return "h-8";
            if (this.size === "sm") return "h-9";
            if (this.size === "lg") return "h-11";
            return "h-10";
        },
    },
    methods: {
        onInput(e) {
            // отдаём РОВНО то, что ввёл пользователь (как ты передавал в setQtyFromInput)
            this.$emit("update:modelValue", e.target.value);
        },
    },
};
</script>
